;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.bpu.show', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var showState = {
      name: 'bpu.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      resolve: {
        bpu: ['$stateParams', 'BpuManager', function ($stateParams, BpuManager) {
          return BpuManager.getById($stateParams.id, BpuManager.query().populate('client'))
        }],
        products: ['$stateParams', 'ProductManager', function ($stateParams, ProductManager) {
          return ProductManager.get(ProductManager.query(
            { conditions: { 'bpu': $stateParams.id } })
          ).then((data) => data.data.map(ids => ids._id))
        }],
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('tmp')
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('bpu', 'model')).then(({ data }) => data)
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/bpu/show/controllers/bpu-show.template.html',
          controller: 'BpuShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/bpu/show/controllers/bpu-show-toolbar.template.html',
          controller: 'BpuShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{toolbar.label}}',
        parent: 'bpu.list'
      }
    }

    $stateProvider
      .state(showState)
  }
})(window.angular)
